module.exports = __webpack_public_path__ + "media/images/vector/left_arrow-657481688999ad75ededaeef6f46b64e.svg";